import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ByToDatePipe } from './by-to-date.pipe';

@NgModule({
  exports: [ByToDatePipe],
  declarations: [ByToDatePipe],
  imports: [CommonModule],
})

export class ByToDateModule {
  
  static forRoot() {
    return {
      ngModule: ByToDateModule,
      providers: [],
    };
  }
  
}
